'use strict';

/**
 * Overview for the community
 *
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Backbone = require('backbone');
var LayoutView = require('base/Colido.LayoutView');
var GroupsLayoutView = require('./groups');
var ContactsView = require('../partials/contacts');

var template = require('modules/community/templates/layout/community.hbs');

var CommunityLayout = LayoutView.extend({
    template: template,

    className: 'community-container',

    regions: {
        contactsRegion: '.contacts-region',
        pendingContactsRegion: '.pending-contacts-region',
        groupsRegion: '.groups-region',
        broadcastsRegion: '.broadcasts-region',
    },

    modelEvents: {
        'change:activeModel': 'activeModelChanged',
    },

    ui: {
        'contactsTab': '.tab-contacts',
        'groupsTab': '.tab-groups',
        'broadcastsTab': '.tab-broadcasts',
        // 'contactsPostCount': '.contacts-posts-count',
        // 'groupsPostCount': '.groups-posts-count',
    },

    activeTab: 'contacts',

    activeConversationId: null,

    initialize: function() {
        LayoutView.prototype.initialize.apply(this, arguments);

        this.listenTo(this.options.conversations, 'update reset change:unreadPosts', this.updateUnreadPostsCount.bind(this));
    },

    onRender: function() {
        var contactsView = new ContactsView({
            collection: this.options.contacts,
            type: 'accepted',
            activeConversationId: this.getOption('activeConversationId'),
            filter: function(model){ return model.get('accepted') === 'YES'; },
        });
        this.contactsRegion.show(contactsView);

        var pendingContactsView = new ContactsView({
            collection: this.options.contacts,
            type: 'pending',
            filter: function(model){ return model.get('accepted') !== 'YES'; },
        });
        this.pendingContactsRegion.show(pendingContactsView);

        var groupsLayoutView = new GroupsLayoutView({
            groups: this.options.groups,
            contacts: this.options.contacts,
            activeConversationId: this.getOption('activeConversationId'),
            type: 'normal',
        });
        this.groupsRegion.show(groupsLayoutView);

        var broadcastsLayoutView = new GroupsLayoutView({
            groups: this.options.groups,
            contacts: this.options.contacts,
            activeConversationId: this.getOption('activeConversationId'),
            type: 'broadcast',
        });
        this.broadcastsRegion.show(broadcastsLayoutView);

        this.updateUnreadPostsCount();
    },

    updateUnreadPostsCount: function() {
        var contactConversations = this.options.conversations.where({type: 'contact'});
        var groupConversations = this.options.conversations.where({type: 'group'});

        var contactsPostsCount = _.reduce(contactConversations, function(memo, conversation) {
            return memo + conversation.get('unreadPosts');
        }, 0);

        var groupsPostsCount = _.reduce(groupConversations, function(memo, conversation) {
            return memo + conversation.get('unreadPosts');
        }, 0);

        // this.ui.contactsTab.attr('title', contactsPostsCount);
        // this.ui.groupsTab.attr('title', groupsPostsCount);

        this.ui.contactsTab.toggleClass('has-undread-posts', !!contactsPostsCount);
        this.ui.groupsTab.toggleClass('has-undread-posts', !!groupsPostsCount);

        // this.ui.contactsPostCount.text(contactsPostsCount).toggle(!!contactsPostsCount);
        // this.ui.groupsPostCount.text(groupsPostsCount).toggle(!!groupsPostsCount);
    },
});

module.exports = CommunityLayout;